import React from 'react'
import { Manager, Reference, Popper } from 'react-popper'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./Popper.css'))

interface Props {
  tooltip: React.ReactNode
  placement: 'top' | 'bottom'
  className?: string
}

const CustomPopper: React.FC<Props> = ({ tooltip, placement, className, children }) => {
  return (
    <Manager>
      <span
        className={bem
          .b('Popper')
          .m(className)
          .show()}
      >
        <Reference>{({ ref }) => <span ref={ref}>{children}</span>}</Reference>
        <Popper placement={placement}>
          {({ ref, style, placement, arrowProps }) => (
            <div
              ref={ref}
              style={style}
              data-placement={placement}
              className={bem
                .b('Popper')
                .e('tooltip')
                .show()}
            >
              {tooltip}
              <div
                className={bem
                  .b('Popper')
                  .e('arrow')
                  .show()}
                ref={arrowProps.ref}
                style={arrowProps.style}
              />
            </div>
          )}
        </Popper>
      </span>
    </Manager>
  )
}

export default CustomPopper
